import React from "react";
import styles from "./styles.module.css";

const Footer = () => {
  return (
    <header className={styles.header}>
      <img className={styles.title} src={require('../../images/logo.png')} />
      <span className={styles.subtitle}> © 2025 EDENLUX CORP. Giữ toàn quyền sở hữu nội dung.<br/>
OTUS – thương hiệu thuộc EDENLUX. Liên hệ với chúng tôi: global@edenlx.com</span>
    </header>
  );
};

export default Footer;
